import {Component, signal} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {PrimeNGRussianLocaleModule} from './core/module/localization-ngprime.module';
import {NotificationComponent} from '../assets/shared/notification/notification.component';
import {filter} from 'rxjs/operators';
import {environment} from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PrimeNGRussianLocaleModule, NotificationComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('Quiz');

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {

        const url = event.urlAfterRedirects;

        if (window._tmr) {
          window._tmr.push({
            id: "3745631",
            type: "pageView",
            url: url
          });
        }

      });
  }

}
